import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  constructor(private readonly router: Router) {}
  private readonly bannerSubject = new Subject<{
    message: string;
    context: string;
    type: string;
    showBanner?: boolean;
    showCloseIcon?: boolean;
  }>();
  banner$ = this.bannerSubject.asObservable();
  // Store dismissed states per context: e.g., { 'CAT': true, 'FSR': false }
  private readonly dismissedContexts = new Map<string, boolean>();
  private readonly bannerDismissedSubject = new Subject<{ context: string, dismissed: boolean }>();
  bannerDismissed$ = this.bannerDismissedSubject.asObservable();

  showBanner(message: string, context = '', type = '', showBanner?: boolean, showCloseIcon = true): void {
    if (context && !this.isActiveContext(context)) {
      return;
    }

    const normalizedContext = context?.trim() || '';
    const isContextDismissed = normalizedContext ? this.dismissedContexts.get(normalizedContext) || false : false;
    const finalShow = isContextDismissed ? false : showBanner;
    this.bannerSubject.next({ message, context, type, showBanner: finalShow, showCloseIcon });
  }

  private isActiveContext(context: string): boolean {
    const normalizedContext = context.trim().toLowerCase();
    const url = this.router.url.toLowerCase();
    return url.includes(`/${normalizedContext}`);
  }

  dismissBanner(context: string, value: boolean): void {
    const normalizedContext = context?.trim() || '';
    if (!normalizedContext) {
      return;
    }
    
    this.dismissedContexts.set(normalizedContext, value);
    this.bannerDismissedSubject.next({ context: normalizedContext, dismissed: value });
  }

  resetBanner(context: string): void {
    const normalizedContext = context?.trim() || '';
    if (normalizedContext) {
      this.dismissedContexts.set(normalizedContext, false);
    }
    // Emit a hidden banner for this context so any currently-displayed
    // banner is removed immediately when the context is reset.
    this.bannerSubject.next({
      message: '',
      context,
      type: 'info',
      showBanner: false,
      showCloseIcon: false,
    });
  }
}
